<template>
  <div class="submission-modal">
    <div class="modal-content">
      <LottieAnimation 
        :animation-data="ConfettiJSON"
        :auto-play="true"
        :loop="true"
        :speed="1"
        ref="anim"
        class="confetti-animation" />
      <div class="icon-container">
        <div class="check-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#2E7BFF" />
            <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      
      <div class="message-container">
        <h2 class="title">Your Account Has Been Successfully Verified</h2>
        <p class="description">We are pleased to inform you that your account verification has been approved. You now have full access to all available features and services.</p>
      </div>
      
      <div class="button-container">
        <button class="ok-button" @click="submit">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { nextPopup } from '../../api/company';
import { buildFormData } from '../../utils/param-builder';
import { LottieAnimation } from "lottie-web-vue";
import ConfettiJSON from '../../../public/assets/confetti.json';

export default {
  name: 'SubmissionModal',
  components: {
    LottieAnimation
  },
  data() {
    return {
      merchantId: 0,
      current_popup: "verified",
      ConfettiJSON
    };
  },
  methods: {
    async submit() {
      try {
        const body = {
          merchant_id: this.merchantId,
          current_popup: this.current_popup
        };
        const response = await nextPopup(buildFormData(body));
        
        if (response.status === 'success') {
          this.$emit('close');
        }
      } catch (err) {
        console.error(err);
      }
    }
  },
  created() {
    this.merchantId = localStorage.getItem("merchantId");
  }
};
</script>

<style scoped>
.submission-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: 40px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  overflow: hidden;
}

.confetti-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; /* Lower z-index for confetti */
}

.icon-container,
.message-container,
.button-container {
  position: relative;
  z-index: 2; /* Higher z-index for text and buttons */
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.check-icon {
  width: 60px;
  height: 60px;
}

.message-container {
  margin-bottom: 24px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.description {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

.button-container {
  display: flex;
  justify-content: center;
}

.ok-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 30px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
}

.ok-button:hover {
  background-color: #3e8e41;
}

.confetti-piece {
  position: absolute;
  z-index: 1;
}
</style>